import React from "react";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
        >
            <path
                d="M1.83301 10.9987C1.83301 5.93609 5.93706 1.83203 10.9997 1.83203C16.0623 1.83203 20.1663 5.93609 20.1663 10.9987C20.1663 16.0613 16.0623 20.1654 10.9997 20.1654C5.93706 20.1654 1.83301 16.0613 1.83301 10.9987Z"
                fill="#FF0000"
            />
            <path
                d="M11 9.16667C11.5063 9.16667 11.9167 9.57707 11.9167 10.0833V15.5833C11.9167 16.0896 11.5063 16.5 11 16.5C10.4937 16.5 10.0833 16.0896 10.0833 15.5833V10.0833C10.0833 9.57707 10.4937 9.16667 11 9.16667Z"
                fill="white"
            />
            <path
                d="M12.375 6.875C12.375 7.63439 11.7594 8.25 11 8.25C10.2406 8.25 9.625 7.63439 9.625 6.875C9.625 6.11561 10.2406 5.5 11 5.5C11.7594 5.5 12.375 6.11561 12.375 6.875Z"
                fill="white"
            />
        </svg>
    );
};
